import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  bannerInfo: {},
};

export const homeBannerSlice = createSlice({
  name: "homeBanner",
  initialState,
  reducers: {
    homeBannerStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    homeBannerSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      bannerInfo: action.payload,
    }),
    homeBannerFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
  },
});

export const {
  homeBannerStart,
  homeBannerSuccess,
  homeBannerFailure,
} = homeBannerSlice.actions;

export const getHomeBannerInfo = () => (dispatch) => {
  dispatch(homeBannerStart());
  apiService.get(Constants.API.HOME_PAGE + Constants.API.HOME_BANNER).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      dispatch(homeBannerSuccess(data?.data));
    } else {
      dispatch(homeBannerFailure());
    }
  }).catch(() => {
    dispatch(homeBannerFailure());
  })
};

export default homeBannerSlice.reducer;
